export enum DocumentTypesEnum {
  CEDULA_CIUDADANIA = 1,
  NIT = 2,
  CEDULA_EXTRANJERIA = 3,
  PASAPORTE = 4,
}




// WEBPACK FOOTER //
// ./src/app/app.enum.ts